import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/sidebar';
import { Topbar } from '@/components/topbar';
import { CommandPalette } from '@/components/command-palette';
import { SoftphoneWidget } from '@/components/softphone-widget';
import { useMessagesRealtime } from '@/lib/messages';
import { SoftphoneProvider } from '@/lib/softphone';

export function AdminShell() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  useMessagesRealtime();
  return (
    <SoftphoneProvider>
      <div className="flex h-full">
        <Sidebar
          surface="admin"
          mobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Topbar onMenuClick={() => setMobileNavOpen(true)} />
          <main className="flex-1 overflow-auto p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
        <CommandPalette />
        <SoftphoneWidget />
      </div>
    </SoftphoneProvider>
  );
}
